import React from 'react';
import DrawerCloseButton from '../DrawerCloseButton/DrawerCloseButton';
import styles from './DrawerHeader.module.scss';
export default function (_ref) {
  var style = _ref.style,
    _ref$hasCloseButton = _ref.hasCloseButton,
    hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? null : _ref$onClose,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    tabindex: "0",
    className: styles.container,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.titleContainer
  }, children), hasCloseButton && /*#__PURE__*/React.createElement("div", {
    className: styles.closeContainer
  }, /*#__PURE__*/React.createElement(DrawerCloseButton, {
    onClick: onClose
  })));
}